import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { OccConfig } from '@spartacus/core'
import { Observable, throwError } from 'rxjs'
import { catchError, retry } from 'rxjs/operators'
import { DocumentDataType } from '../models/enum/documentDataType.enum'

@Injectable({
  providedIn: 'root'
})
export class FileService {
  constructor(
    private http: HttpClient,
    private occConfig: OccConfig
  ) {}

  public mimeConvertor(mimeType: string): string {
    let extention = ''
    switch (mimeType) {
      case 'application/msword': {
        extention = '.doc'
        break
      }
      // case 'application/msword': {
      //   extention = '.exe'
      //   break
      // }
      case 'application/pdf': {
        extention = '.pdf'
        break
      }
      case 'application/postscript': {
        extention = '.eps'
        break
      }
      case 'application/rtf': {
        extention = '	.rtf'
        break
      }
      case 'application/x-gtar': {
        extention = '.gtar'
        break
      }
      case 'application/x-gzip': {
        extention = '.gz'
        break
      }
      case 'application/x-java-archive': {
        extention = '.jar'
        break
      }
      case 'application/x-java-serialized-object': {
        extention = '.ser'
        break
      }
      case 'application/x-java-vm': {
        extention = '.class'
        break
      }
      case 'application/x-tar': {
        extention = '.tar'
        break
      }
      case 'application/zip': {
        extention = '.zip'
        break
      }
      case 'audio/x-aiff': {
        extention = '.aiff'
        break
      }
      case 'audio/basic': {
        extention = '.ua'
        break
      }
      case 'audio/x-midi': {
        extention = '.midi'
        break
      }
      case 'audio/x-wav': {
        extention = '.wav'
        break
      }
      case 'image/bmp': {
        extention = '.bmp'
        break
      }
      case 'image/gif': {
        extention = '.gif'
        break
      }
      case 'image/jpeg': {
        extention = '.jpg'
        break
      }
      case 'image/tiff': {
        extention = '.tiff'
        break
      }
      case 'image/x-xbitmap': {
        extention = '.xbm'
        break
      }
      case 'multipart/x-gzip': {
        extention = '.gzip'
        break
      }
      case 'multipart/x-zip': {
        extention = '.zip'
        break
      }
      case 'text/html': {
        extention = '.html'
        break
      }
      case 'text/plain': {
        extention = '.txt'
        break
      }
      case 'text/richtext': {
        extention = '.rtf'
        break
      }
      case 'text/csv': {
        extention = '.csv'
        break
      }
      case 'video/mpeg': {
        extention = '.mpg'
        break
      }
      case 'video/vnd.vivo': {
        extention = '.vivo'
        break
      }
      case 'video/quicktime': {
        extention = '.mov'
        break
      }
      case 'video/x-msvideo': {
        extention = '.avi'
        break
      }
      default: {
        extention = ''
        break
      }
    }

    return extention
  }
  public getDocumentDataType(documentDataType: string): string {
    let dataType: string
    switch (documentDataType) {
      case DocumentDataType.productInfo: {
        dataType = DocumentDataType.productInfo
        break
      }
      case DocumentDataType.highQualityImage: {
        dataType = DocumentDataType.highQualityImage
        break
      }
      case DocumentDataType.mountingInstruction: {
        dataType = DocumentDataType.mountingInstruction
        break
      }
      default: {
        dataType = DocumentDataType.productInfo
        break
      }
    }
    return dataType
  }

  public uploadFile(file: File, uploadDocumentURL: string): Observable<any> {
    const formData = new FormData()
    formData.append('file', file[0])
    return this.http.post(uploadDocumentURL, formData)
  }

  public getPdfDocument(mediaUrl: string): Observable<any> {
    const baseUrl = this.occConfig.backend.occ.baseUrl
    return this.http
      .get(`${baseUrl}${mediaUrl}`, {
        observe: 'response',
        responseType: 'blob'
      })
      .pipe(retry(1), catchError(this.handleError))
  }

  public b64toBlobConvertor(b64Data: string, contentType: string): Blob {
    contentType = contentType || ''
    const sliceSize = 512
    b64Data = b64Data.replace(/^[^,]+,/, '')
    b64Data = b64Data.replace(/\s/g, '')
    const byteCharacters = window.atob(b64Data)
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize)

      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)

      byteArrays.push(byteArray)
    }

    const blob = new Blob(byteArrays, { type: contentType })
    return blob
  }

  private handleError(error: HttpErrorResponse): any {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message)
    } else {
      console.error(`Backend returned code ${error.status}, ` + `error: ${error.error}`)
    }
    return throwError('Error happened. please try again later.')
  }
}
